import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import { isMobile } from '@/utils/common.js'

import pc from './pc'
import mobile from './mobile'

const routes = [
  ...pc,
  ...mobile,
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title

  // 获取当前路由
  const fullPath = to.fullPath
  // 判断是否为移动端路由
  const pattern = new RegExp(/(\/m$)|(\/m\?)|(\/m\/)/)
  const hasMobileFlag = pattern.test(fullPath)
  // 判断是否为移动端
  const mobile = isMobile()

  // 获取新的路由地址
  let newPath = ''
  if (mobile && !hasMobileFlag) {
    newPath = `/m${fullPath}`
  } else if (!mobile && hasMobileFlag) {
    newPath = fullPath.replace('\/m\/', '/')
  }

  if (newPath) {
    next(newPath)
  } else {
    next()
  }
})

export default router
